import React from 'react'
import { Link } from "react-router-dom";
import "../../styles/ventajas.css"
import Logo from '../Reutilizables/Logo'
import TituloImpuestosMunicipales from '../Reutilizables/TituloImpuestosMunicipales'
import Redes from "../Reutilizables/Redes"
import Footer from "../Reutilizables/Footer"

function Ventajas() {
  return (
    <>
        <div className='container-logo-menu'> 
          <Logo />
        </div>
        <div className='titulo-impuestos-ventajas'>
          <TituloImpuestosMunicipales />
        </div>
        <Redes />
        <div className="container-ventajas">

            <section className="section-capacitaciones">
              <Link to="/login-simple" className='nav-link-ventajas'> <h3> Capacitaciones. </h3> </Link>
            </section>

            <section className="section-noticias">
              <Link to="/login-simple" className='nav-link-ventajas'> <h3> Noticias diarias. </h3> </Link>
            </section>

            <section className="section-publicaciones">
              <Link to="/login-simple" className='nav-link-ventajas'> <h3> Publicaciones. </h3> </Link>
            </section>

            <section className="section-solicitud">
              <Link to="/login-simple" className='nav-link-ventajas'> <h3> Solicitud de documentos. </h3> </Link>
            </section>

            <section className="section-carga">
              <Link to="/login-simple" className='nav-link-ventajas'> <h3> Descarga de documentos a su correo electrónico. </h3> </Link>
            </section>

            <section className="section-blog">
              <Link to="/login-simple" className='nav-link-ventajas'> <h3> Blog donde encontrara información de su interes. </h3> </Link>
            </section>

            <section className="section-tienda">
              <Link to="/login-simple" className='nav-link-ventajas'> <h3> Tienda - TRIBUTOS Y FINANZAS. </h3> </Link>
            </section>

          </div>
          <Footer />
    </>
  )
}

export default Ventajas